import ItemDiscordSvg from "../PublicComponents/svgtsx/component-discord-svg";
import ItemGithubSvg from "../PublicComponents/svgtsx/component-github-svg";
import ItemGmailSvg from "../PublicComponents/svgtsx/component-gmail-svg";
import ItemTwitterSvg from "../PublicComponents/svgtsx/component-twitter-svg";
import ItemLinkedinSvg from "../PublicComponents/svgtsx/component-linkedin-svg";

export const ArraySvgComponents = [
  {
    link: "https://github.com/MindfulLearner",
    svg: ItemGithubSvg,
  },
  {
    link: "https://www.linkedin.com/in/joshua-dimaunahan-473977195/",
    svg: ItemLinkedinSvg,
  },
  {
    link: "mailto:dimajosh1009@gmail.com",
    svg: ItemGmailSvg,
  },
  {
    link: "https://twitter.com/fungo93",
    svg: ItemTwitterSvg,
  },
  {
    link: "https://github.com/MindfulLearner",
    svg: ItemDiscordSvg,
  },
];
